export default "__VITE_ASSET__DORFxGrK__"